export enum BrandingTypeEnum {
    video = "branding_video",
    presentation = "branding_presentation",
}
